// // socketService.js
// import { io } from "socket.io-client";

// const SOCKET_URL = process.env.REACT_APP_BASE_SIGNIN_URL; // Replace with your backend URL

// const socket = io(SOCKET_URL);

// export default socket;

import { io } from "socket.io-client";
import { clog } from "../lib/utils";
// This is a service to manage socket connections in a React application.
class SocketService {
  socket = null;
  connected = false;

  initialize() {
    const loginData = localStorage.getItem("login_data");
    if (!loginData) {
      return;
    }

    const parsedData = JSON.parse(loginData);
    const userId = parsedData?.resp_user?.id;

    if (!userId || this.socket) {
      return;
    }

    this.socket = io(process.env.REACT_APP_BASE_SIGNIN_URL);

    this.socket.on("connect", () => {
      this.connected = true;
      clog("Socket connected");
      this.socket.emit("join", userId);
    });

    this.socket.on("disconnect", () => {
      this.connected = false;
      clog("Socket disconnected");
    });
  }

  isConnected() {
    return this.connected;
  }

  on(event, callback) {
    if (this.socket) {
      this.socket.on(event, callback);
    }
  }

  off(event, callback) {
    if (this.socket) {
      this.socket.off(event, callback);
    }
  }

  emit(event, data) {
    if (this.socket) {
      this.socket.emit(event, data);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.connected = false;
      clog("Socket disconnected");
    } else {
      clog("Socket not connected");
    }
  }
}

export const socketService = new SocketService();
